document.addEventListener('DOMContentLoaded', function() {
    var dropZone = document.getElementById('drop_zone');

    dropZone?.addEventListener('dragenter', function(e) {
        // Ajoutez une classe lorsque survolée pour drag and drop
        this.classList.add('over');
    }, false);

    dropZone?.addEventListener('dragleave', function(e) {
        // Supprimez la classe lorsque le survol pour drag and drop est terminé
        this.classList.remove('over');
    }, false);

    dropZone?.addEventListener('drop', function(e) {
        // Supprimez la classe lorsque le fichier est effectivement déposé
        this.classList.remove('over');
    }, false);
});